<style>
  .el-dialog-div{
    height: 550px;
  }

  .join-business-jl{
    margin-left: 10px;
  }

</style>
<template lang="html">
  <list-template ref="list-template" :queryParams="queryParams" actionUrl="lcwpbusiness/findBusiness.action">
    <template slot="search" scope="scope">
      <el-row :gutter="20">
        <channel-select ref="channelSelect" v-belong-to-admin clearable filterable placeholder="展示渠道"
                        @change="channelIdsChange"></channel-select>
        <el-select class="join-business-jl" v-model="queryParams.viewStatus" clearable placeholder="上架状态" style="margin-left:20px;"
                   @change="onStatusChange">
          <el-option :value="1" label="上架"></el-option>
          <el-option :value="2" label="下架"></el-option>
        </el-select>

        <el-select class="join-business-jl" v-model="queryParams.type" clearable placeholder="商家类型"
                   @change="$refs['list-template'].search()">
          <el-option label="4s店" value="4s店"></el-option>
          <el-option label="综合汽贸" value="综合汽贸"></el-option>
          <el-option label="机油保养" value="机油保养">机油保养</el-option>
          <el-option label="洗车打蜡" value="洗车打蜡">洗车打蜡</el-option>
          <el-option label="汽车用品" value="汽车用品">汽车用品</el-option>
          <el-option label="改装装潢" value="改装装潢">改装装潢</el-option>
          <el-option label="汽车维修" value="汽车维修">汽车维修</el-option>
          <el-option label="车驾管服务" value="车驾管服务">车驾管服务</el-option>
          <el-option label="保险服务" value="保险服务">保险服务</el-option>
          <el-option label="驾培服务" value="驾培服务">驾培服务</el-option>
          <el-option label="其他商户" value="其他商户">其他商户</el-option>
        </el-select>

        <el-select class="join-business-jl" v-model="queryParams.serviceType" clearable placeholder="服务类型"
                   @change="$refs['list-template'].search()">
          <el-option label="新车" value="新车"></el-option>
          <el-option label="二手车" value="二手车"></el-option>
          <el-option label="机油保养" value="机油保养"></el-option>
          <el-option label="洗车打蜡" value="洗车打蜡"></el-option>
          <el-option label="汽车用品" value="汽车用品"></el-option>
          <el-option label="改装装潢" value="改装装潢"></el-option>
          <el-option label="汽车维修" value="汽车维修"></el-option>
          <el-option label="车驾管服务" value="车驾管服务">车驾管服务</el-option>
          <el-option label="保险服务" value="保险服务">保险服务</el-option>
          <el-option label="驾培服务" value="驾培服务">驾培服务</el-option>
          <el-option label="其他服务" value="其他服务"></el-option>
        </el-select>

        <el-date-picker class="join-business-jl" v-model="queryParams.createTime" end-placeholder="创建开始时间" start-placeholder="创建结束时间"
                        type="daterange" @change="onCreateTimeChange">
        </el-date-picker>

        <el-input class="join-business-jl" style="width: 150px;" v-model="queryParams.keyword" placeholder="商家名/电话/地址"></el-input>

        <el-button @click="search()">搜索</el-button>
        <slot name="addButton">
          <el-button v-permissions="'addBusinessPermession'" type="primary" @click="$router.push('/home/addPlusBusiness')">新增商家
          </el-button>
        </slot>
      </el-row>
    </template>
    <template slot="item" scope="scope">
      <el-card  style="height: 220px;" v-for="data in scope.datas" class="basic-margin" >
        <el-row >
          <el-col :span="3">
            <img :src="data.headImg" style="width:150px;height:100px;">
          </el-col>
          <el-col :span="17">
            <h4 style="margin-top: -2px">
              {{ data.businessName }}
            </h4>
            <h4>
              <el-tag size="small" type="warning">{{ data.channelName }}</el-tag>
              <el-tag :type="data.status==1?'success':'danger'" size="small" style="margin-left: 10px;">{{
                data.status |
                statusFilter
                }}
              </el-tag>
              <el-tag size="small" style="margin-left: 10px;" type="info">{{ data.type }}</el-tag>
              <el-tag size="small" style="margin-left: 10px;" type="info">在售商品 {{ data.goodsSize }} 件</el-tag>
              <el-tag size="small" style="margin-left: 10px;" type="info">{{ data.loginDays ? data.loginDays : 0 }}
                天未登录
              </el-tag>
              <el-tag v-if="data.carShowName" size="small" style="margin-left: 10px;" type="danger">
                {{ data.carShowName }}
              </el-tag>
              <el-tag v-if="data.inviterName" size="small" type="info">
                <el-tooltip class="item" effect="dark"  :content="data.inviterPhone" placement="top">
                  <span>邀请人：{{ data.inviterName }}</span>
                </el-tooltip>
              </el-tag>

              <el-tag v-if="data.deviceType != 1 " size="small" style="margin-left: 10px;">{{
                data.deviceType |
                deviceTypeFilter
                }}
              </el-tag>

              <el-tag v-if="data.isSendMungBean == 1 "  size="small" style="margin-left: 10px;">环保奖励已开通
              </el-tag>
            </h4>
            <p>公司地址：{{ data.detailAddress }}</p>

            <p>服务类型：{{ data.serviceType }}</p>

            <p>管理人员：{{ data.contacts }} - {{ data.phone }}</p>

            <p>创建时间：{{
                data.createTime |
                    dateTimeFormat
              }}</p>

          </el-col>
          <el-col :span="4" style="text-align:right;">
            <slot :data="data">
              <el-row :gutter="10">
                <el-col >
                  排序值：{{ data.sortNum }}
                </el-col>
              </el-row>
              <el-dropdown>

               <span class="el-dropdown-link">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                      @click.native.prevent="$router.push({name:'商家plus商品', params: { businessId: data.id }})">商品管理
                  </el-dropdown-item>

                  <el-dropdown-item @click.native.prevent="showStaticData(data.id)" >今日数据看板</el-dropdown-item>

                  <el-dropdown-item @click.native.prevent="showOrderData(data.id)" >查看收支汇总</el-dropdown-item>

                  <el-dropdown-item v-confirm-input :confirm-input-data="{id:data.id}" confirm-input-text="确定排序商家"
                                    confirm-input-type="number" requestUrl="lcwpbusiness/updateSortNum.action"
                                    @onInputConfirm="onInputConfirm">排序
                  </el-dropdown-item>

                  <el-dropdown-item v-confirm
                                    :confirm-data="{id:data.id,status:4}"
                                    confirm-text="确认删除该商家"
                                    :style="{color:data.status==1?'#f55c5c':'#57c23a'}"
                                    requestUrl="lcwpbusiness/changeBusinessStatus.action" @onConfirm="$refs['list-template'].search()">
                   删除
                  </el-dropdown-item>

                  <el-dropdown-item v-confirm
                                    :confirm-data="{id:data.id,status:data.status==1?2:1}"
                                    :confirm-text="data.status==1?'确认下架该商家？':'确认上架该商家？'"
                                    :style="{color:data.status==1?'#f55c5c':'#57c23a'}"
                                    requestUrl="lcwpbusiness/changeBusinessStatus.action" @onConfirm="$refs['list-template'].search()">
                    {{ data.status == 1 ? '下架商家' : '上架商家' }}
                  </el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="$router.push({name:'修改plus商家', params: { id: data.id }})">
                    修改商家
                  </el-dropdown-item>
                  <el-dropdown-item v-permissions="'addJoinCar'" @click.native.prevent="showJoinCarShowDialog(data)">
                    参加车展
                  </el-dropdown-item>
                  <el-dropdown-item  v-permissions="'deviceTypePermissions'"  @click.native.prevent="showDeviceType(data)">安装点开通
                  </el-dropdown-item>

                  <el-dropdown-item  v-permissions="'mungBeanPermissions'"  @click.native.prevent="showMungBean(data)">环保奖励开通
                  </el-dropdown-item>

                  <el-dropdown-item v-confirm-input :confirm-input-data="{id:data.id}" confirm-input-text="确定修改手机号"
                                    value-alias="phone" requestUrl="lcwpbusiness/updateLoginAccount.action"
                                    @onInputConfirm="onInputConfirm">修改手机号
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

            </slot>
          </el-col>

        </el-row>
      </el-card>

      <el-dialog :visible.sync="dialogStaticDataVisible" label-width="70px" title="今日数据看板"
                 width="30%" id="businessStaticData">
        <div class="el-dialog-div">
          <el-form ref="form" v-form :model="businessStaticData" label-width="100px">

            <el-row >
              <el-col :span="12">
                <el-form-item label="今日访客量：" >
              <span style="color: red;"> {{businessStaticData.todayBrowseCount?businessStaticData.todayBrowseCount:0}}次
              </span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="累计访客量：" >
              <span > {{businessStaticData.browseCount}}次
              </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row >

              <el-col :span="12">
                <el-form-item label="今日拨打量：" >
              <span style="color: red;">{{businessStaticData.todayPhoneCount}}次
              </span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="累计拨打量：" >
                <span> {{businessStaticData.phoneCount}}次
                </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row >

              <el-col :span="12">
                <el-form-item label="今日订单量：" >
                <span style="color: red;"> {{businessStaticData.todayOrderCount}} 笔
                </span>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="累计订单量：" >
              <span > {{businessStaticData.orderCount}}笔
              </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row >
            <el-col :span="12">
              <el-form-item label="今日交易额：" >
              <span style="color: red;"> {{businessStaticData.todayOrderMoney/100}}元
              </span>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="累计交易额：" >
              <span > {{businessStaticData.orderMoney/100}}元
              </span>
              </el-form-item>
            </el-col>
            </el-row>

            <el-row >
              <el-col :span="12">
                <el-form-item label="今日已结算：" >
                    <span style="color: red;"> {{businessStaticData.todayIncomeMoney/100}}元
                    </span>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="累计已结算：" >
              <span> {{businessStaticData.incomeMoney/100}}元
              </span>
                </el-form-item>
              </el-col>
            </el-row>

              <el-row>

                <el-col :span="12">
                  <el-form-item label="待核销订单：" >
                    <span style="color: red;"> {{businessStaticData.orderDeclareCount}}笔
                    </span>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="未结算金额：" >
                    <span> {{businessStaticData.orderDeclareMoney/100}}元
                    </span>
                  </el-form-item>
                </el-col>

              </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="累计已提现：" >
                    <span style="color: red;">
                        {{businessStaticData.withdrawBusinessMoney/100}}元
                    </span>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="当前可提现：" >
                    <span> {{businessStaticData.canUseMoney/100}}元
                    </span>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogOrderFormVisible" label-width="80px" title="查看收支汇总"
                 width="50%">
        <el-row>

          <el-date-picker type="datetimerange" v-model="dialogOrderForm.startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="handleTime()">
          </el-date-picker>

        </el-row>

        <el-table :data="orderDatas" class="basic-margin" style="width: 100%">
          <el-table-column label="日期">
            <template scope="scope">
              {{scope.row.dayStr}}
            </template>
          </el-table-column>
          <el-table-column label="订单量（笔）">
            <template scope="scope">
              {{scope.row.count}}
            </template>
          </el-table-column>
          <el-table-column label="交易金额(元)">
            <template scope="scope">
              {{scope.row.orderMoney/100}}
            </template>
          </el-table-column>
          <el-table-column label="结算金额(元)">
            <template scope="scope">
              {{scope.row.money/100}}
            </template>
          </el-table-column>
        </el-table>

        <row>
          <el-pagination
                  :current-page="orderCurrentPage"
                  :page-size="orderPageSize"
                  :page-sizes="[1,10, 20, 50, 100]"
                  :total="orderTotalCount"
                  @current-change="handleOrderCurrentChange"
                  @size-change="handleOrderSizeChange"
                  class="row basic-margin"
                  layout="total, sizes, prev, pager, next, jumper"
                  style="margin-left:0px">
          </el-pagination>
        </row>
        <row>
          <br>
          累计订单量：{{orderTotalCount}}笔     &nbsp;&nbsp;累计交易金额：{{orderMoney/100}}元  &nbsp;&nbsp; 累计结算金额：{{money/100}}元
        </row>

      </el-dialog>
      <join-car-show-dialog ref="joinCarShowDialog" @onSuccess="$refs['list-template'].search()"></join-car-show-dialog>
      <set-device-type ref="setDeviceType" @onSuccess="$refs['list-template'].search()"></set-device-type>
      <set-mung-bean ref="setMungBean" @onSuccess="$refs['list-template'].search()"></set-mung-bean>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
import JoinCarShowDialog from './children/JoinCarShowDialog'
import setDeviceType from './children/setDeviceType'
import setMungBean from './children/setMungBean'
import BasicModel from '@/framework/basic/BasicModel'
import DateUtil from '@/framework/utils/DateUtil'

export default {
  name: 'joined-business',
  extends: BasicPager,
  data: function () {
    return {
      orderCurrentPage: 1, // 起始
      orderPageSize: 10, // 步长
      orderTotalCount: 0, // 总条数
      orderMoney: 0, // 交易金额
      money: 0, // 结算金额
      dialogOrderFormVisible: false,
      businessStaticData: {},
      dialogStaticDataVisible: false,
      orderDatas: null,
      dialogOrderForm: {
        startEndTime: null,
        startTime: null,
        endTime: null,
        businessId: null
      },
      queryParams: {
        businessId: null,
        createMode: null,
        createTime: '',
        startTime: null,
        endTime: null,
        keyword: '',
        status: '1',
        type: null,
        viewStatus: '上架',
        channelId: null
      }
    }
  },
  components: {
    ListTemplate,
    channelSelect,
    JoinCarShowDialog,
    setDeviceType,
    setMungBean
  },
  props: {
    carShowId: {
      type: Number,
      default: null
    }
  },
  watch: {
    carShowId (newValue) {
      this.queryParams.carShowId = newValue
      this.$refs['list-template'].loadList()
    }
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    },
    deviceTypeFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '关闭安装点'
          break
        case 2:
          str = '普通安装点'
          break
        default:
          str = '区域独家安装点'
      }

      return str
    }
  },
  created: function () {
    if (this.loginInfo.loginPath === 'channel') {
      this.queryParams.channelId = this.loginInfo.id
    }

    if (this.carShowId) {
      this.queryParams.carShowId = this.carShowId
    }
    this.dialogOrderForm.startEndTime = [DateUtil.getNDayTime(-30), DateUtil.getDayEndTime()]
  },

  methods: {
    // 监听页数变化
    handleOrderSizeChange (val) {
      this.orderPageSize = val
      this.loadOrderData()
    },
    // 监听页码变化
    handleOrderCurrentChange (val) {
      this.orderCurrentPage = val
      this.loadOrderData()
    },
    showOrderData: function (id) {
      this.dialogOrderForm.businessId = id
      this.loadOrderData()
      this.dialogOrderFormVisible = true
    },
    handleTime: function () {
      this.orderCurrentPage = 1
      this.loadOrderData()
    },
    loadOrderData: function () {
      let _this = this
      let params = {
        businessId: this.dialogOrderForm.businessId,
        pageNum: this.orderCurrentPage,
        pageSize: this.orderPageSize

      }

      if (_this.dialogOrderForm.startEndTime && _this.dialogOrderForm.startEndTime.length === 2) {
        let startTime = _this.dialogOrderForm.startEndTime[0]
        let endTime = _this.dialogOrderForm.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.orderDatas = dataInfo.datas.result
          _this.orderTotalCount = dataInfo.datas.total
          _this.orderMoney = dataInfo.datas.orderMoney
          _this.money = dataInfo.datas.money
        }
      }
      let action = 'lcwpbusiness/findTransactionDetails.action'
      BasicModel.get(this, action, params, listener)
    },
    showStaticData: function (id) {
      this.loadStaticData(id)
      this.dialogStaticDataVisible = true
    },
    loadStaticData: function (id) {
      let _this = this
      let params = {
        businessId: id
      }

      let listener = {
        success: function (dataInfo) {
          _this.businessStaticData = dataInfo.datas
        }
      }
      let action = 'lcwpbusiness/getBusinessStaticData.action'
      BasicModel.get(this, action, params, listener)
    },
    showDeviceType: function (data) {
      this.$refs['setDeviceType'].showDeviceType(data)
    },
    showMungBean: function (data) {
      this.$refs['setMungBean'].showMungBean(data)
    },
    search () {
      this.$refs['list-template'].search()
    },
    showJoinCarShowDialog (data) {
      let businessId = data.id
      let carShowId = data.carShowId
      let carShowName = data.carShowName
      this.$refs['joinCarShowDialog'].showDialog(businessId, carShowId, carShowName)
    },
    onCreateTimeChange: function () {
      let createTime = this.queryParams.createTime

      if (createTime && createTime[0]) {
        this.queryParams.startTime = createTime[0].getTime()
        this.queryParams.endTime = createTime[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }

      this.$refs['list-template'].search()
    },
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.queryParams.channelId = channelId
      } else {
        this.queryParams.channelId = null
      }

      this.$refs['list-template'].search()
    },
    onStatusChange: function (value) {
      if (!value) {
        this.queryParams.status = '1,2'
      } else {
        this.queryParams.status = value
      }

      this.$refs['list-template'].search()
    },
    onCreateModeChange: function (value) {
      if (!value) {
        delete this.queryParams.createMode
      }
      this.$refs['list-template'].search()
    },
    onInputConfirm: function () {
      this.$refs['list-template'].search()
    }
  }
}
</script>

<style lang="css" scoped>
.el-row {
  margin-bottom: 20px;

}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
</style>
